<template>
  <div>
    <div class="box-wp" v-if="profile">
      <div class="head-box">
        <div class="c-flex c_flex_center">
          <h4>个性化配置</h4>
        </div>
      </div>
      <div class="box-detail">
        <div class="box-center">
          <el-card class="box-card">
            <div slot="header">
              <span>更改菜单栏</span>
            </div>
            <div class="box-item">
              <span class="field-label">更改菜单栏背景颜色 ：</span>
              <el-radio-group v-model="profile.menuBarBgColor" @change="doSave">
                <el-radio label="default">系统默认</el-radio>
                <el-radio label="red">红色</el-radio>
                <el-radio label="green">绿色</el-radio>
                <el-radio label="blue">蓝色</el-radio>
              </el-radio-group>
              <aside style="margin-top:15px;">
                提示：与侧边栏上的选择主题色选择不同，它是两种不同的换肤。
              </aside>
            </div>
          </el-card>

          <div class="tag-item-block" style="font-size:20px">
            效果展示，预览示例：
          </div>

          <div class="tag-item-block">
            <el-button type="primary">系统按钮</el-button>
            <el-button type="primary" icon="el-icon-search">搜索按钮</el-button>
          </div>

          <div class="tag-item-block">
            <el-link type="primary">示例链继</el-link>
            <el-link :underline="false" style="margin:0 15px">示例链继</el-link>
            <el-link>示例链继</el-link>
          </div>

          <div class="tag-item-block">
            <el-radio-group v-model="radio">
              <el-radio :label="3">选择 A</el-radio>
              <el-radio :label="6">选择 B</el-radio>
              <el-radio :label="9">选择 C</el-radio>
            </el-radio-group>
          </div>

          <div class="tag-item-block">
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in tags"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-date-picker
              style="margin-left:15px"
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>

          <div>
            <el-slider v-model="slideValue" />
          </div>
        </div>
        <div class="box-right-Personalize" :class="collapse ? 'box-collapse' : ''">
          <div class="box-right-header" style="display: flex;justify-content: space-between;">
            <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
            <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
            <el-button
              v-show="!collapse"
              style="margin:10px 0"
              @click="doOpen"
              v-if="osg.has('Personalize,config')"
            >
              租户全部配置
            </el-button>
            <el-button v-show="!collapse" style="margin:10px 0" @click="doSave">应用</el-button>
          </div>
          <div class="box-right-content" v-show="!collapse">
            <div class="box-right-content-inner">
              <el-form
                :model="profile"
                label-width="140px"
                label-position="top"
                hide-required-asterisk
              >
                <el-form-item label="主题色">
                  <ThemePicker
                    style="margin-left: 5px;"
                    @themeColor="themeColor"
                    :profileTheme="profile"
                  />
                </el-form-item>
                <el-form-item label>
                  <template slot="label">
                    浏览器标题
                  </template>
                  <el-input type="text" v-model="profile.browserTitle">
                    <!-- <el-button slot="append" @click="titleConfirm">应用</el-button> -->
                  </el-input>
                </el-form-item>
              </el-form>

              <c-form
                label-position="top"
                :formData="profile"
                :fields="extFields"
                :area="area"
                :options="options"
                ref="form"
                @changeForm="osg.changeForm"
              >
                <template slot="depositRatio">
                  <!-- <template slot="label"> -->
                  设置预付比例(%)
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="设置该项将影响对订单支付的预付比例"
                    placement="top-end"
                  >
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                  <!-- </template> -->
                  <div class="c-flex w-100 c-flex-between">
                    <el-input-number
                      placeholder="设置该项将影响对订单支付的预付比例"
                      class="w-100 c-m-r-15"
                      style="flex: 1;"
                      v-model="profile.depositRatio"
                      :precision="0"
                      :step="1"
                      :max="100"
                    ></el-input-number>
                  </div>
                </template>
                <template slot="warnPhones">
                  <!-- <template slot="label"> -->
                  设置预警电话
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="设置该项的手机号将收到系统推送来的预警短信"
                    placement="top-end"
                  >
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                  <!-- </template> -->
                  <div class="c-flex w-100 c-flex-between">
                    <el-input
                      type="textarea"
                      placeholder="设置该项的手机号将收到系统推送来的预警短信"
                      v-model="profile.exts.warnPhones"
                    ></el-input>
                    <!-- <el-button @click="doSave">应用</el-button> -->
                  </div>
                </template>
              </c-form>
              <el-form
                :model="profile"
                label-width="140px"
                label-position="top"
                hide-required-asterisk
              >
                <el-form-item label="浏览器icon图片">
                  <template slot="label">
                    浏览器icon图片
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="浏览器左上角小图标"
                      placement="top-end"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </template>
                  <el-upload
                    :class="{ maxLimit: iconProfileFileList.length > 0 }"
                    :action="iconUpload.url"
                    :data="iconUpload.data"
                    :file-list="iconProfileFileList"
                    list-type="picture-card"
                    :limit="upload.limit"
                    :on-exceed="osg.uploadExceed"
                    :before-upload="
                      file => {
                        return osg.beforeUpload(file, 'image', 'iconUpload');
                      }
                    "
                    :on-success="
                      (response, file, fileList) => {
                        return doSave({
                          browserIcon: upload.downloadUrl + response.key
                        });
                      }
                    "
                    :on-error="osg.uploadError"
                    :before-remove="
                      (file, fileList) => {
                        return beforeRemove(file, fileList, 'fileList');
                      }
                    "
                    :on-remove="
                      (file, fileList) => {
                        return onIconRemove(file, fileList, 'fileList');
                      }
                    "
                    :on-preview="inconPreivew"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog
                    :modal="false"
                    custom-class="dialog-img"
                    :visible.sync="iconUpload.dialogVisible"
                  >
                    <img width="100%" :src="iconUpload.dialogImageUrl" alt />
                  </el-dialog>
                </el-form-item>
                <el-form-item label="logo图片(200×50)">
                  <el-upload
                    :class="{ maxLimit: profileFileList.length != 0 }"
                    :action="upload.url"
                    :data="upload.data"
                    :file-list="profileFileList"
                    list-type="picture-card"
                    :limit="upload.limit"
                    :on-exceed="osg.uploadExceed"
                    :before-upload="
                      file => {
                        return osg.beforeUpload(file, 'image');
                      }
                    "
                    :on-success="
                      (response, file, fileList) => {
                        return doSave({
                          logo: upload.downloadUrl + response.key
                        });
                      }
                    "
                    :on-error="osg.uploadError"
                    :before-remove="
                      (file, fileList) => {
                        return beforeRemove(file, fileList, 'fileList');
                      }
                    "
                    :on-remove="
                      (file, fileList) => {
                        return onRemove(file, fileList, 'fileList');
                      }
                    "
                    :on-preview="preivew"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog
                    :modal="false"
                    custom-class="dialog-img"
                    :visible.sync="upload.dialogVisible"
                  >
                    <img width="100%" :src="upload.dialogImageUrl" alt />
                  </el-dialog>
                </el-form-item>
                <el-form-item label="logo缩略图图片(60×50)">
                  <template slot="label">
                    logo缩略图图片(60×50)
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="左侧菜单栏收缩时展示的logo图片"
                      placement="top-end"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </template>
                  <el-upload
                    :class="{ maxLimit: profileThumbnailFileList.length != 0 }"
                    :action="thumbnailUpload.url"
                    :data="thumbnailUpload.data"
                    :file-list="profileThumbnailFileList"
                    list-type="picture-card"
                    :limit="thumbnailUpload.limit"
                    :on-exceed="osg.uploadExceed"
                    :before-upload="
                      file => {
                        return osg.beforeUpload(file, 'image', 'thumbnailUpload');
                      }
                    "
                    :on-success="
                      (response, file, fileList) => {
                        return doSave({
                          smallLogo: thumbnailUpload.downloadUrl + response.key
                        });
                      }
                    "
                    :on-error="osg.uploadError"
                    :before-remove="
                      (file, fileList) => {
                        return beforeRemove(file, fileList, 'fileList');
                      }
                    "
                    :on-remove="
                      (file, fileList) => {
                        return thumbnailRemove(file, fileList, 'fileList');
                      }
                    "
                    :on-preview="thumbnailPreivew"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog
                    :modal="false"
                    custom-class="dialog-img"
                    :visible.sync="thumbnailUpload.dialogVisible"
                  >
                    <img width="100%" :src="thumbnailUpload.dialogImageUrl" alt />
                  </el-dialog>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="租户全部配置"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="display: flex;flex-direction: column;width: 100%;">
        <el-button class="c-m-b-10" @click="addExt()">新增ext字段</el-button>
        <div
          class="configList-wrapper"
          style="
            height: 400px;
            overflow: auto;
            border: 1px solid #DCDFE6;
            padding: 10px;
            box-sizing: border-box;
            border-radius: 3px;
          "
        >
          <div v-for="(item, index) in profileList" :key="index" class="c-m-b-10">
            <template v-if="!forbidModifyList.includes(item.key)">
              <template v-if="item.key != 'exts'">
                <div :class="`c-flex c-flex-item c-flex-between`">
                  <el-input
                    v-model="item.key"
                    disabled
                    placeholder="请输入key"
                    style="flex:1"
                  ></el-input>
                  <div style="flex: 2;align-items: center;" class="c-m-l-10 c-flex c-flex-around">
                    <el-input v-model="item.value" :placeholder="item.value">
                      <el-button slot="append">
                        <!-- <el-checkbox v-model="checked">备选项</el-checkbox> -->
                        <el-popover placement="right" width="400" trigger="click">
                          <el-input
                            v-model="item.value"
                            type="textarea"
                            :placeholder="item.value"
                            rows="30"
                          ></el-input>
                          <el-button slot="reference" icon="el-icon-zoom-in"></el-button>
                        </el-popover>
                      </el-button>
                    </el-input>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-for="(extsItem, extIndex) in item.value" :key="extIndex" class="c-m-b-10">
                  <div :class="`c-flex c-flex-item c-flex-between`">
                    exts.
                    <el-input v-model="extsItem.key" placeholder="请输入key" style="flex:1">
                      <template slot="append">
                        <el-select style="width:100px" v-model="extsItem.type" placeholder="请选择">
                          <el-option
                            v-for="item in [
                              { label: 'object', value: '' },
                              { label: 'number', value: 'number' },
                              { label: 'string', value: 'string' }
                            ]"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </template>
                    </el-input>
                    <div style="flex: 2;align-items: center;" class="c-m-l-10 c-flex c-flex-around">
                      <el-input v-model="extsItem.value">
                        <el-button slot="append">
                          <el-popover placement="right" width="400" trigger="click">
                            <el-input
                              v-model="extsItem.value"
                              type="textarea"
                              :placeholder="extsItem.value"
                              rows="30"
                            ></el-input>
                            <el-button slot="reference" icon="el-icon-zoom-in"></el-button>
                          </el-popover>
                        </el-button>
                      </el-input>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="doConfigSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { toggleClass } from "@/utils";
import '@/resources/custom-theme/theme.css'; // the theme changed version element-ui css
// import areajs from '../resources/js/area.js';
import ThemePicker from '@/components/ThemePicker.vue';

export default {
  name: 'Personalize',
  components: {
    ThemePicker
  },
  inject: ['getProfile'],
  data() {
    let $this = this;
    return {
      menuTheme: '',
      tags: [{ label: '示例1', value: '1' }, { label: '示例2', value: '2' }],
      value: '',
      slideValue: 55,
      radio: 3,
      value1: '',
      collapse: false,
      color: '#545C64',
      //以上均为假数据/示例数据
      profile: {
        menuBarBgColor: 'default',
        exts: {}
      },
      extFields: [], //租户配置扩展字段
      options: {},
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 1
      },
      thumbnailUpload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 1
      },
      iconUpload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 1
      },
      //省市区
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      //logo的数组
      profileFileList: [],
      //logo 缩略图的数组
      profileThumbnailFileList: [],
      //icon 图片的数组
      iconProfileFileList: [],
      openDetail: false,
      profileList: [], //租户配置字段列表
      forbidModifyList: [
        '_id',
        '_version',
        'state',
        'createTime',
        'updateTime',
        'createUser',
        'updateUser',
        'createUserName',
        'updateUserName',
        'orgId',
        'orgName',
        'tenantId',
        'belongTo',
        'depositRatio',
        'warnPhones'
      ] //禁止修改字段
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('tenantConfig', () => {
      this.osg.codeoption();
    });
  },
  methods: {
    doInit() {
      window.$this = this;
      this.openDetail = false;
      this.getProfileInfo();
    },
    //获取当前租户信息
    getProfileInfo(callback) {
      var tenantID = JSON.parse(sessionStorage['entity']).entityID;
      this.osg.ajax(
        'biz/tenantConfig/findById.do',
        {
          tenantId: tenantID
        },
        res => {
          if (res.entity) {
            //对扩展的预警电话特殊处理
            if (res.entity.exts && res.entity.exts.warnPhones) {
              res.entity.exts.warnPhones = Array.isArray(res.entity.exts.warnPhones)
                ? res.entity.exts.warnPhones.join()
                : res.entity.exts.warnPhones;
            }
            this.profile = res.entity;
            this.profile.exts = res.entity.exts || {};
            //处理预付比例
            if (this.profile.depositRatio)
              this.profile.depositRatio = this.amountToFixed(this.profile.depositRatio * 100);
            let obj = {
              themeColor: this.profile.themeColor,
              menuBarBgColor: this.profile.menuBarBgColor,
              logo: this.profile.logo,
              smallLogo: this.profile.smallLogo,
              browserIcon: this.profile.browserIcon,
              browserTitle: this.profile.browserTitle,
              saLength: this.profile.saLength,
              depositRatio: this.profile.depositRatio
            };
            if (obj.logo) this.profileFileList = [{ url: this.profile.logo }];
            if (obj.browserIcon) this.iconProfileFileList = [{ url: this.profile.browserIcon }];
            if (obj.smallLogo) this.profileThumbnailFileList = [{ url: this.profile.smallLogo }];
            this.$forceUpdate();
          }
          if (callback) callback();
        }
      );
    },
    doSave(data) {
      var parma = Object.assign(this.profile, data);
      //预付比例特殊处理
      if (parma.depositRatio) parma.depositRatio = this.amountToFixed(parma.depositRatio / 100);
      if (parma.exts && parma.exts.warnPhones) {
        //对扩展的预警电话特殊处理
        parma.exts.warnPhones = Array.isArray(parma.exts.warnPhones)
          ? parma.exts.warnPhones
          : parma.exts.warnPhones && parma.exts.warnPhones.split(',');
      }
      //   console.log(parma.exts.warnPhones);
      parma = Object.assign(this.profile, parma);
      debugger;
      // console.log(parma);
      this.osg.ajax('biz/tenantConfig/upsert.do', { tenantConfig: JSON.stringify(parma) }, res => {
        // localStorage.setItem("FSGOtheme", JSON.stringify(parma));
        this.osg.toast('保存成功！');
        this.getProfile();
        this.getProfileInfo(() => {
          // location.reload()
          this.$forceUpdate();
        });
        // that.$emit("customRefresh", true);
      });
    },
    //保留两位小数的
    amountToFixed(money) {
      if (!money) return 0;
      return +(+money).toFixed(2) ? +(+money).toFixed(2) : 0;
    },
    themeColor(val) {
      this.doSave({ themeColor: val });
    },
    titleConfirm() {
      // this.$emit("titleBroswer", this.profile.title);

      this.doSave({ browserTitle: this.profile.browserTitle });
    },
    beforeRemove(file, fileList, field) {
      let status = true;
      if (file && file.status === 'success') {
        status = this.$confirm('确定删除？');
      }
      return status;
    },
    preivew() {
      this.upload.dialogImageUrl = this.profileFileList[0].url;
      this.upload.dialogVisible = true;
    },
    inconPreivew() {
      this.iconUpload.dialogImageUrl = this.iconProfileFileList[0].url;
      this.iconUpload.dialogVisible = true;
    },
    thumbnailPreivew() {
      this.thumbnailUpload.dialogImageUrl = this.profileThumbnailFileList[0].url;
      this.thumbnailUpload.dialogVisible = true;
    },
    thumbnailRemove(file, fileList, field) {
      if (file && file.status === 'success') {
        this.profile.smallLogo = '';
        this.profileThumbnailFileList = [];
        this.doSave({ smallLogo: '' });
      }
    },
    onIconRemove(file, fileList, field) {
      if (file && file.status === 'success') {
        this.profile.browserIcon = '';
        this.iconProfileFileList = [];
        this.doSave({ browserIcon: '' });
      }
    },
    onRemove(file, fileList, field) {
      if (file && file.status === 'success') {
        this.profile.logo = '';
        this.profileFileList = [];
        this.doSave({ logo: '' });
      }
    },
    toggleClass(element, className) {
      document.body.removeAttribute('class');
      if (!element || !className) {
        return;
      }
      let classString = element.className;
      const nameIndex = classString.indexOf(className);
      if (nameIndex === -1) {
        classString += '' + className;
      } else {
        classString =
          classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
      }
      element.className = classString;
    },
    //打开配置窗口、处理数据
    doOpen() {
      this.profileList = [];
      for (let key in this.profile) {
        if (key != 'exts') {
          this.profileList.push({
            key: key,
            value: this.profile[key]
          });
        }
      }
      let extsList = [];
      for (let key in this.profile.exts) {
        extsList.push({
          key: key,
          type:
            typeof this.profile.exts[key] == 'number'
              ? 'number'
              : typeof this.profile.exts[key] == 'string'
              ? 'string'
              : '',
          value:
            typeof this.profile.exts[key] != 'string'
              ? JSON.stringify(this.profile.exts[key])
              : this.profile.exts[key]
        });
      }
      this.profileList.push({
        key: 'exts',
        value: extsList
      });
      console.log(this.profileList);
      this.openDetail = true;
    },
    //新增扩展字段
    addExt() {
      this.profileList[this.profileList.length - 1].value.push({ key: '', value: '' });
      this.scrollToBottom();
      this.$forceUpdate();
    },
    //控制到底部
    scrollToBottom() {
      this.$nextTick(() => {
        var container = this.$el.querySelector('.configList-wrapper');
        container.scrollTop = container.scrollHeight;
      });
    },
    //处理并保存配置
    doConfigSave() {
      let obj = { exts: {} }; //tenantConfig对象
      this.profileList.forEach(item => {
        if (item.key) {
          if (item.key != 'exts') {
            obj[item.key] = item.value;
          } else {
            item.value.forEach(eItem => {
              if (eItem.key) {
                if (eItem.type == 'string') eItem.value = String(eItem.value);
                if (eItem.type == 'number') eItem.value = Number(eItem.value);
                obj.exts[eItem.key.replace(/\s/g, '')] = this.osg.isJson(eItem.value)
                  ? JSON.parse(eItem.value)
                  : eItem.value;
              }
            });
          }
        }
      });
      //预付比例特殊处理
      if (obj.depositRatio) obj.depositRatio = this.amountToFixed(obj.depositRatio / 100);
      if (obj.exts && obj.exts.warnPhones) {
        //对扩展的预警电话特殊处理
        obj.exts.warnPhones = Array.isArray(obj.exts.warnPhones)
          ? obj.exts.warnPhones
          : obj.exts.warnPhones && obj.exts.warnPhones.split(',');
      }
      // return;
      this.osg.ajax('biz/tenantConfig/upsert.do', { tenantConfig: JSON.stringify(obj) }, res => {
        this.osg.toast('保存成功！');
        this.getProfile();
        this.doInit();
      });
    }
  },
  watch: {
    profile: {
      handler(newValue) {
        if (newValue) {
          switch (newValue.menuBarBgColor) {
            case 'red':
              this.toggleClass(document.body, 'custom-theme-bg-red');
              break;
            case 'green':
              this.toggleClass(document.body, 'custom-theme-bg-green');
              break;
            case 'blue':
              this.toggleClass(document.body, 'custom-theme-bg-blue');
              break;
            default:
              document.body.removeAttribute('class');
          }
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.box-wp {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.field-label {
  vertical-align: middle;
}
.box-card {
  width: 400px;
  max-width: 100%;
  margin: 20px auto;
}

.tag-item-block {
  padding: 30px 24px;
}

.tag-item {
  margin-right: 15px;
}
.box-right-content-inner {
  padding: 20px 20px;
  box-sizing: border-box;
}
.box-right-Personalize {
  border-left: 1px solid #dfe3eb;
  /*/flex-basis: 20%;*/
  /*  max-width: 500px;
  */
  min-width: 320px;
  display: flex;
  flex-direction: column;
  transition: flex 0.5s cubic-bezier(0.16, 0.84, 0.44, 1);
  will-change: flex;
}
.box-collapse {
  flex-basis: 50px !important;
  min-width: 50px !important;
}
.box-center {
  background-color: transparent;
}
.box-detail {
  flex: 1;
}
.el-radio-group {
  display: flex;
}
>>> .el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 88px;
  height: 88px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
>>> .el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 88px;
  height: 88px;
  line-height: 96px;
  vertical-align: top;
}
.maxLimit >>> .el-upload.el-upload--picture-card {
  display: none;
}
>>> .el-dialog__body {
  display: flex;
}
>>> .el-dialog {
  width: 1100px !important;
}
</style>
